<template>
    <Modal 
      :id="'cmp-dt-load-task'" 
      @cancelled="onCancel"
    >
      <template slot="header"> {{$t('load_tasks')}}</template>
      <template slot="body">
        <div class="item-container">
          <button
            class="dt-button v1 s6"
            @click.stop="addNew(taskGroup)"
            v-for="taskGroup in taskGroups"
          >
            {{ $t(taskGroup['task_template_group'])}}
          </button>
          <!-- <button 
            class="dt-button s6 btn-width"
            style="margin-left: 10px;" 
            @click.stop="onCancel"
          >Cancel
          </button> -->
        </div>
      </template>
      <template slot="options">
     
        <button 
          class="dt-button s6" 
          @click.stop="onCancel"
        >Cancel</button>
           <!-- <button
          class="dt-button v1 with-ico"
           :class="{ disabled: !isFormValid }"
          :disabled="!isFormValid"
          @click.stop="addNewLicenceAccount"
        >
          {{$t('ok')}}
        </button> -->
      </template>
    </Modal>
  </template>
  
  <script>
  
  import Modal from '@dtplugins/modal/modal';
import { dtTaskService } from './dt-task-service';

  

  export default {
    components: {
      Modal,
    },
    props: {
      
    },
    data: function() {
      return {
        taskGroups:[]
      };
    },
    mounted:async function() {
      
      const res = await dtTaskService.taskTabLoad(this.externalTable);
      
      this.taskGroups = res.data.task_groups;

      console.log("TTTTTTTTT",res)

    },
    computed: {
      externalTable: function () {
       return this.$route.query.externalTable;
      },
    },
    methods: {

      onCancel: function() {
        this.$emit("cancelled", true);
      },
       addNew: async function(e) {
    
        // this.$router.push({
        //   ...this.$route,
        //   query: {
        //     modal: "add_new_asset_modal",
        //     payload: { licence_id:this.licence_id ,asset_type:e  }
        //   },
        // });
        this.$emit('onLoadTask', {...e});
      },
      //MARK: Methods
    }
  };
  
  
  </script>
  
  <style lang="scss">
  .cmp-dt-load-task {
    .dt-modal--header{
      text-align: center;
    }
    .item-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .s6 {
        margin: 10px;
        width: 100%;
        min-width: 220px;
      }

    }
    .btn-width{
      max-width: 200px;
      min-width: 200px;
     // padding:0px 10px;
    }
  }
  </style>